import React from 'react';
import { ErrorPage, RootNode } from '@hugendubel/react-basic';
import ReactDOM from 'react-dom';

const Page: React.FC = () => (
    <div className="page-container error-page">
        <ErrorPage />
    </div>
);

const open = () => ReactDOM.render(<Page />, RootNode.get());

export const Fallback = { open, Page };
